<template>
  <router-view></router-view>
</template>

<script>
export default {

}
</script>

<style>
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  .table td {
    white-space: nowrap;
  }

  html, body {
    margin: 0;
    width: 100%;
  }

  #app {
    padding: 10px;
    background-color: #F6F6F6;
    border-radius: 5px;
  }

  body {
    overflow: auto;
    overflow-x: hidden;
  }

  th {
    outline: none;
    text-align: center !important;
  }

  tr {
    outline: none;
  }

  td {
    text-align: center;
  }

  /* bootstrap-vue override */
  select {
    background: url("./assets/select_arrow.svg") no-repeat right .75rem center !important;
    border: none !important;
    color: #707070 !important;
  }

  .selects {
    display: flex;
  }

  /* bootstrap-vue override */
  select:focus {
    box-shadow: none !important;
  }

  /* Pace loader */
  .pace,.pace .pace-progress {
    z-index: 9999;
  }

  .pace .pace-progress {
    background: #000000;
  }

  /* https://vue-select.org/ */
  #context-selector .vs__actions {
    background-color: #000000;
    height: 50px;
    width: 50px;
    position: relative;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  #context-selector .vs__open-indicator {
    fill: white;
    display: inline-block;
    float: none;
    position: absolute;
    top: 0;
    left: 0;
    background: url('./assets/dropdown_arrow.svg') center/20px no-repeat;
    width: 100%;
    height: 100%;

    box-shadow: 0 0 0 0 rgba(122, 186, 30, 1);
    transform: scale(1);
    animation: pulse 2s 5;
  }

  /* https://www.florin-pop.com/blog/2019/03/css-pulse-effect/ */
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(122, 186, 30, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 20px rgba(122, 186, 30, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(122, 186, 30, 0);
    }
  }

  .vs__open-indicator {
    background: url('./assets/dropdown_arrow_green.svg') center/contain no-repeat;
    width: 20px;
    height: 10px;
  }

  /* bootstrap-vue override */
  .custom-select:disabled {
    color: #6c757d !important;
    background-color: #e9ecef !important;
  }

  /* bootstrap-vue override */
  .table-hover tbody tr:hover {
    color: #7ABA1E !important;
    background-color: rgba(122,186,30,.075) !important;
  }

  /* bootstrap-vue override */
  .table-success, .table-success>td, .table-success>th, .table-success>tr {
    outline: none;
    background-color: #7ABA1E !important;
    color: white !important;
  }

  /* bootstrap-vue override */
  .sku-input {
    background: url("./assets/pencil.svg") no-repeat right .75rem center;
    background-size: 19px;
    border: none !important;
    background-color: #f6f5f6 !important;
    border-bottom: 1px solid #CCCCCC !important;
    max-width: 320px;
    border-radius: 0 !important;
    outline: none !important;
    box-shadow: none !important;
  }

  .tooltip-inner {
    font-size: 12px;
  }

  .context-selector .vs__dropdown-toggle {
    height: 50px;
  }

  /* https://vue-select.org/guide/css.html#overriding-default-styles */
  .context-selector .vs__search::placeholder,
  .context-selector .vs__dropdown-toggle,
  .context-selector .vs__dropdown-menu {
    background: white;
    border: none;
    color: #7ABA1E;
    text-transform: lowercase;
    font-variant: small-caps;
  }
  .context-selector .vs__dropdown-option:hover,
  .context-selector .vs__dropdown-option--highlight {
    background: #F6F6F6 url("./assets/context_selector_arrow.svg") no-repeat left .75rem center;
    background-size: 0.5rem;
    color: #666666;
  }
  .context-selector .vs__dropdown-option {
    background: url("./assets/context_selector_arrow.svg") no-repeat left .75rem center;
    background-size: 0.5rem;
    padding-left: 2rem;
    height: 45px;
    display: flex;
    align-items: center;
  }
  .context-selector .vs__clear,
  .context-selector .vs__open-indicator {
    fill: #7ABA1E;
  }

  .origin-selector .vs__search::placeholder,
  .origin-selector .vs__dropdown-toggle,
  .origin-selector .vs__dropdown-menu {
    background: white;
    border: none;
    color: #7ABA1E;
    text-transform: lowercase;
    font-variant: small-caps;
  }
  .origin-selector .vs__dropdown-option:hover,
  .origin-selector .vs__dropdown-option--highlight {
    background: #F6F6F6;
    color: #666666;
  }
  .origin-selector .vs__clear,
  .origin-selector .vs__open-indicator {
    fill: #7ABA1E;
  }

  .vs__selected {
    color: #666666 !important;
    position: inherit !important;
  }

  .vld-overlay:focus {
    outline: none
  }

  .ga-background {
    background: #FFF url("./assets/logo-google-analytics.svg") no-repeat center center !important;
    background-size: 128px !important;
  }

  .ga-icon-offset {
    top: 20%;
  }

  .card-align-text {
    display: -webkit-inline-box !important;
    -webkit-box-align: center;
  }

  /* products */
  .table-increment {
    background: url("./assets/increment_arrow.svg") no-repeat right .75rem center;
  }

  .table-decrement {
    background: url("./assets/decrement_arrow.svg") no-repeat right .75rem center;
  }

  /* common */
  .custom-link {
    color: #666666;
  }

  .custom-link:hover {
    color: #7ABA1E;
    text-decoration: none;
  }

  .bullet-box {
    margin-right: 6px;
    width: 12px;
    height: 12px;
  }

  .small-bullet-box {
    margin-right: 6px;
    width: 10px;
    height: 10px;
  }

  .text-base {
    color: #666666;
    font-family: 'Open Sans', sans-serif !important;
  }

  .text-30 {
    font-size: 30px !important;
    font-weight: 400 !important;
  }

  .text-24 {
    font-size: 24px !important;
    font-weight: 400 !important;
  }

  .text-22 {
    font-size: 22px !important;
    font-weight: 400 !important;
  }

  .text-20 {
    font-size: 20px !important;
    font-weight: 400 !important;
  }

  .text-18 {
    font-size: 18px !important;
    font-weight: 400 !important;
  }

  .text-16 {
    font-size: 16px !important;
    font-weight: 400 !important;
  }

  .text-14 {
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  .text-12 {
    font-size: 12px !important;
    font-weight: 400 !important;
  }

  .text-6 {
    font-size: 6px !important;
    font-weight: 300 !important;
  }

  .rb {
    background-color: #FF524F !important;
  }

  .yb {
    background-color: #FCBC2C !important;
  }

  .bb {
    background-color: #0BA7DA !important;
  }

  .gb {
    background-color: #7ABA1E !important;
  }

  .white-box {
    padding: 4px;
    background-color: white;
    box-shadow: #00000008 0 0 6px 0;
    border-radius: 5px;
  }

  .align-items-center {
    align-items: center;
  }

  .two-d-center {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
  }

  .line-height-1 {
    line-height: 1.2
  }

  .highcharts-legend text, #receipt_visits_conversion_graph .highcharts-data-label text {
    fill: #666666 !important;
  }
</style>
